import { Team } from 'contexts/teams/types';

// Expects the user's team memberships (session.user.teams): the account teams list (GET /teams/)
// has no is_manager. Team.is_manager is typed as an optional string but users/me sends a boolean;
// String(...) handles both without treating "false" as truthy.
export const canManageTeamDeadline = (
  isAccountOwner: boolean,
  userTeams: Team[] | null | undefined,
  teamId: string
): boolean => {
  if (isAccountOwner) return true;

  const managedTeam = userTeams?.find((team) => team.id === teamId || team.team_id === teamId);
  return String(managedTeam?.is_manager) === 'true';
};
